import Button from './button';

export default class Secondary extends Button {
  get buttonClass() {
    return 'ds-button--secondary';
  }
}
